import * as React from "react";
import ShowroomToastProvider, { ToastOptions } from "@carvana/showroom-toast";
import { createRegisteredContext, getContext } from "react-singleton-context";

import "@carvana/showroom-toast/index.css";

export type ContextValue = (opt: ToastOptions) => void;

const ToastContext = createRegisteredContext<ContextValue | undefined>(
  "ToastContext",
  undefined,
);

type Props = {
  children: React.ReactNode;
};

export function ToastProvider({ children }: Props) {
  return (
    <ShowroomToastProvider
      render={({ showToast }) => {
        return (
          <ToastContext.Provider value={showToast}>
            {children}
          </ToastContext.Provider>
        );
      }}
    />
  );
}

export function useToast(): ContextValue {
  const contextValue = React.useContext(getContext(ToastContext));
  if (contextValue === undefined) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return contextValue;
}
